import { render, staticRenderFns } from "./BasicFileUpload.vue?vue&type=template&id=fd97e5e8&"
import script from "./BasicFileUpload.vue?vue&type=script&lang=js&"
export * from "./BasicFileUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports